var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"https://www.paytel.pl/","title":"paytel"}},[_c('logo-component',{staticClass:"logo",attrs:{"light":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }